import { render } from "./Geofencing.vue?vue&type=template&id=385ded3e&scoped=true&ts=true"
import script from "./Geofencing.vue?vue&type=script&lang=ts"
export * from "./Geofencing.vue?vue&type=script&lang=ts"

import "./Geofencing.vue?vue&type=style&index=0&id=385ded3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385ded3e"]])

export default __exports__